import { render, staticRenderFns } from "./PassReset.vue?vue&type=template&id=392529a3&"
import script from "./PassReset.vue?vue&type=script&lang=js&"
export * from "./PassReset.vue?vue&type=script&lang=js&"
import style0 from "./PassReset.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PassReset.vue"
export default component.exports